import { useSelector } from "react-redux";
import type { ReportField } from "../../../../../../../../api/types/svTypes.ts";
import { useAppDispatch } from "../../../../store/hooks/useAppDispatch.ts";
import { selectListSettingsState } from "../../../../store/selectors/fieldsStateSelectors.ts";
import { fieldsStateActions } from "../../../../store/thunks/fieldStatesThunks.ts";
import SwitchMenuItem from "../../common/fields/field-options/SwitchMenuItem.tsx";

interface Props {
  field: ReportField;
  readonly: boolean;
}

const ListFreezeField = ({ field, readonly }: Props) => {
  const dispatch = useAppDispatch();
  const { freezedColumns } = useSelector(selectListSettingsState);
  const isFieldFreezed = freezedColumns.includes(field.config.guid);

  const handleClick = () => {
    const nextFreezedColumns = isFieldFreezed
      ? freezedColumns.filter((column) => column !== field.config.guid)
      : [...freezedColumns, field.config.guid];
    dispatch(fieldsStateActions.updateSettings({ settings: { freezedColumns: nextFreezedColumns } }));
  };

  return (
    <SwitchMenuItem
      caption={isFieldFreezed ? "Unfreeze Column" : "Freeze Column"}
      value={isFieldFreezed}
      onClick={handleClick}
      disabled={readonly}
    />
  );
};

export default ListFreezeField;
